/**
 * Remove duplicate provider account payment options
 * @param {object[]} paymentOptions Array of formatted payment options according to schemas
 * @returns {object[]} Deduplicated payment options
 */
export default function deduplicatePaymentOptions(paymentOptions) {
	return paymentOptions.reduce((uniqueOptions, option) => {
		let duplicateOption;
		if (option.type === 'creditCard' && option.card) {
			duplicateOption = uniqueOptions.filter((uniqueOption) => {
				return uniqueOption.type === 'creditCard' && uniqueOption.card;
			}).find((uniqueOption) => {
				const sameMonth = uniqueOption.card.expirationMonth === option.card.expirationMonth;
				const sameYear = uniqueOption.card.expirationYear === option.card.expirationYear;
				const sameBrand = uniqueOption.card.brand === option.card.brand;
				const sameLastFourDigits = uniqueOption.card.lastFourDigits === option.card.lastFourDigits;
				return sameMonth && sameYear && sameBrand && sameLastFourDigits;
			});
		}
		if (option.type === 'payPalBilling' && option.owner.billing.email) {
			duplicateOption = uniqueOptions.filter((uniqueOption) => {
				return uniqueOption.type === 'payPalBilling' && uniqueOption.owner.billing.email;
			}).find((uniqueOption) => {
				return option.owner.billing.email === uniqueOption.owner.billing.email;
			});
		}
		if (!duplicateOption) {
			uniqueOptions.push(option);
		}
		return uniqueOptions;
	}, []);
}
